import { Injectable } from '@angular/core';
import { CrossStudyPortalAppConfig } from '../interfaces/app-config';
import { AppConfigLoaderService } from './app-config-loader.service';

@Injectable({
  providedIn: 'root',
})
export class ApiUrlService {
  private _apiUrl: string | undefined;

  constructor(appConfig: AppConfigLoaderService<CrossStudyPortalAppConfig>) {
    appConfig.getConfig$()?.subscribe({
      next: v => {
        this._apiUrl = v.apiUrl;
      },
      error: () => console.warn('error while setting apiUrl'),
    });
  }

  get(): string {
    if (!this._apiUrl) throw new Error('apiUrl is not set. it must be set during initialization');
    return this._apiUrl;
  }
}
